import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=0760c501&scoped=true&"
import script from "./FeedbackPage.vue?vue&type=script&lang=ts&"
export * from "./FeedbackPage.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackPage.vue?vue&type=style&index=0&id=0760c501&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0760c501",
  null
  
)

export default component.exports